export const SET_PAGE_VALUE = 'hardwarefitting/SET_PAGE_VALUE';
export const SET_HARDWARE_OPTIONS = 'hardwarefitting/SET_HARDWARE_OPTIONS';
export const SET_SELECTED_HARDWARE_OPTION = 'hardwarefitting/SET_SELECTED_HARDWARE_OPTION';
export const SET_NEW_SELECTED_HARDWARE_OPTION = 'hardwarefitting/SET_NEW_SELECTED_HARDWARE_OPTION';
export const SET_HARDWARE_SELECTION_HINT = 'hardwarefitting/SET_HARDWARE_SELECTION_HINT';
export const SET_HARDWARE_SELECTION_ENABLED = 'hardwarefitting/SET_HARDWARE_SELECTION_ENABLED';
export const SET_ACCESS_TYPE = 'hardwarefitting/SET_ACCESS_TYPE';
export const REMOVE_SELECTED_HARDWARE_OPTION = 'hardwarefitting/REMOVE_SELECTED_HARDWARE_OPTION';

